module.exports = __webpack_public_path__ + "img/gongzhonghao.3abcacfa.png";